import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Services
//******************************************************************************

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';

//******************************************************************************
//  Document Finder Components
//******************************************************************************
import { DOCUMENT_FINDER_COMPONENTS } from '~/components/document-finder';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

const components: any[] = [
    HomeComponent,
    ...DOCUMENT_FINDER_COMPONENTS,
];

const services: any[] = [
];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
    ],
    declarations: [
        ...components,
        SafePipe,
    ],
    exports: [
        ...components,
    ],
    providers: [
        ...services,
    ],
})

export class AppImports { }
